export class DocHistory {
  doc_name: string;
  doc_uri: string;
  state: string;
  timestamp: Date;
}
